import * as angular from 'angular';

import { IDispatcherService, IDispatcher, IApiInformationActionsService } from '../';
import { IApiInformation } from '../../models';

export interface IApiInformationStoreService {
    getApiInformation(): angular.IPromise<IApiInformation>;
}

export interface IApiInformationActionsDispatcherService extends IDispatcherService<IApiInformationStoreService> { }

export class ApiInformationActionsDispatcherService implements IApiInformationActionsDispatcherService {
    static serviceId = 'apiInformationActionsDispatcherService';

    static $inject = ['apiInformationActionsService'];

    constructor(private _actionService: IApiInformationActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<IApiInformationStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                getApiInformation: () => dispatch(actionService.getApiInformation())
            }
        };
    }
}